
























































































































/*eslint-disable */
/* tslint:disable */
import { computed, defineComponent, Ref, ref } from '@vue/composition-api';
import LayerCheckbox                           from '@/components/map/overlays/LayerCheckbox.vue';
import SubLayerCheckbox         from '@/components/map/overlays/SubLayerCheckbox.vue';
import useOptions               from '@/components/composers/useOptions';
import store                    from '@/store';

const LayerSelector: object = defineComponent({
  components: {
    LayerCheckbox,
    SubLayerCheckbox,
  },
  name: 'LayerSelector',
  setup() {
    let windowWidth = window.innerWidth;
    const isSmall = ref(windowWidth > 768 ? false : true);

    return {
      isSmall,
      ...useOptions(),
    };
  },
  methods: {
    checkVal(val: keyof any): boolean {
      const visibilityOfModules = store.state.mapSettings.settings.visibilityOfModules;
      const findVal = Object.entries(visibilityOfModules).find((item, key) => item[0] === val);

      return !!findVal ? findVal[1] : false;
    },
  }
});
export default LayerSelector;
